import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import Popconfirm from "@/shared/feedback/pop-confirm";
import Form from "@/shared/form/form";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { useReadConfirmationTypeGuard } from "../model/use-read-confirmation-type-guard";
import { CompanyDocumentReadConfirmationType } from "gql/graphql";

export function SaveCompanyDocumentSubmit({
  loading,
  initialReadConfirmationType,
  hasConfirmations,
}: {
  loading: boolean;
  initialReadConfirmationType?: CompanyDocumentReadConfirmationType;
  hasConfirmations: boolean;
}) {
  const t = useDocumentsTranslations();
  const form = Form.useFormInstance();
  const { needsWarning } = useReadConfirmationTypeGuard({
    initialType: initialReadConfirmationType,
    hasConfirmations,
  });

  return (
    <SubmitWrapper>
      <Popconfirm
        disabled={!needsWarning}
        title={t("Read confirmation type")}
        description={t("Change read confirmation type warning")}
        onConfirm={() => form.submit()}
      >
        <SubmitButton
          loading={loading}
          htmlType={needsWarning ? "button" : "submit"}
        />
      </Popconfirm>
    </SubmitWrapper>
  );
}
